import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import PendoLib, { LEARNER_API_KEY } from 'js/lib/pendo';
import { useParams } from 'js/lib/useRouter';
import { get, isAuthenticatedUser, isCourserian } from 'js/lib/user';

import EnterpriseSkillPathwayPageRootContent from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseSkillPathwayPageRootContent';
import EnterpriseSkillPathwayPageDataProvider from 'bundles/enterprise-learning-path-description-page/providers/pages/EnterpriseSkillPathwayPageDataProvider';
import EnterprisePageTemplateWrapper from 'bundles/unified-common/pageUtils/EnterprisePageTemplateWrapper';

const EnterpriseSkillPathwayPageRoot = () => {
  const { programSlug } = useParams();
  React.useEffect(() => {
    try {
      PendoLib.init(
        {
          visitor: {
            id: get().external_id,
            isLoggedIn: isAuthenticatedUser(),
            isCourserian: isCourserian(),
          },
          account: {
            isEnterprise: true,
            // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
            programSlug,
          },
        },
        LEARNER_API_KEY
      );
    } catch {
      // do nothing
    }
  }, [programSlug]);
  return (
    <div data-testid="enterprise-skill-pathway-page">
      <EnterpriseSkillPathwayPageDataProvider>
        <EnterprisePageTemplateWrapper>
          <EnterpriseSkillPathwayPageRootContent />
        </EnterprisePageTemplateWrapper>
      </EnterpriseSkillPathwayPageDataProvider>
    </div>
  );
};

export default compose(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'enterprise_skill_pathway_description_page',
      page: 'enterprise_skill_pathway_page',
    },
  }))
)(EnterpriseSkillPathwayPageRoot);
